import type { ReactNode } from "react";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import Container from "../Container";
import ScrollContainer from "../ScrollContainer";
import CustomSearchbar, { type CustomSearchbarProps } from "../Searchbar";
import BottomAppBar from "./BottomAppBar";

export type OnboardingLayoutProps = {
	onPrimaryPress?: () => void;
	primaryActionLabel?: string;
	children: ReactNode;
	onSecondaryPress?: () => void;
	secondaryActionLabel?: string;
	selectedItemLabel?: string;
	selectedItemText?: string;
	disabled?: boolean;
	disabledSecondary?: boolean;
	onSearchChange?: (text: string) => void;
	searchbarProps?: CustomSearchbarProps;
	useScroll?: boolean;
	containerPaddingVertical?: number;
};

const OnboardingLayout = ({
	children,
	onPrimaryPress,
	onSecondaryPress,
	primaryActionLabel = "Continue",
	secondaryActionLabel,
	selectedItemLabel,
	selectedItemText,
	disabled,
	disabledSecondary,
	onSearchChange,
	searchbarProps,
	useScroll = true,
	containerPaddingVertical = 16,
}: OnboardingLayoutProps) => {
	const { isMobile } = useDevice();
	return (
		<Box flex={1}>
			{onSearchChange ? (
				<Container
					maxWidth="xs"
					autoSize
					containerStyle={{
						paddingHorizontal: isMobile ? 16 : 0,
						paddingVertical: 16,
					}}
				>
					<CustomSearchbar
						onChangeText={onSearchChange}
						value={searchbarProps?.value ?? ""}
						traileringIcon={"magnify"}
						{...searchbarProps}
					/>
				</Container>
			) : null}
			{useScroll ? (
				<ScrollContainer
					contentContainerStyle={{
						flexGrow: 1,
						paddingVertical: containerPaddingVertical,
					}}
					containerProps={{
						containerStyle: { flex: 1 },
					}}
					maxWidth="xs"
				>
					{children}
				</ScrollContainer>
			) : (
				<Container
					maxWidth="xs"
					containerStyle={{
						paddingVertical: containerPaddingVertical,
					}}
				>
					{children}
				</Container>
			)}
			{onPrimaryPress && (
				<BottomAppBar
					onPrimaryPress={onPrimaryPress}
					onSecondaryPress={onSecondaryPress}
					primaryActionLabel={primaryActionLabel}
					secondaryActionLabel={secondaryActionLabel}
					selectedItemLabel={selectedItemLabel}
					selectedItemText={selectedItemText}
					disabled={disabled}
					disabledSecondary={disabledSecondary}
				/>
			)}
		</Box>
	);
};

export default OnboardingLayout;
